export default "__VITE_ASSET__13b0ddd0__"